// utils/handleEmojis.js
export const handleEmoji = (
  emoji,
  textRef,
  text,
  setText,
  setCursorPosition,
) => {
  const ref = textRef?.current;
  const emojiStr = emoji || '';

  if (!ref) {
    setText((prev) => (prev || '') + emojiStr);
    return;
  }

  if (document.activeElement !== ref) ref.focus();

  const start = ref.selectionStart ?? text.length;
  const end = ref.selectionEnd ?? text.length;
  const newText = text.slice(0, start) + emojiStr + text.slice(end);
  setText(newText);

  const newCursor = start + emojiStr.length;
  setCursorPosition(newCursor);

  setTimeout(() => {
    try {
      ref.setSelectionRange(newCursor, newCursor);
    } catch {}
  }, 0);
};
